export const WorldWideOption = {
  Default: 'Default',
  Worldwide: 'Worldwide',
  Custom: 'Custom',
}
